export default {
  'ambassador.start': 'Become a Biconomy STAR',
  'ambassador.become': 'Become a member of our community and be at the forefront of digital innovation',
  'ambassador.li_1': 'Amazing Community',
  'ambassador.li_2': 'Earning Opportunities',
  'ambassador.li_3': 'Blockchain Expertise',
  'ambassador.COLABORATE': 'LET’S COLABORATE',
  'ambassador.join': 'Join our ambassador program today and become part of our outstanding community.',
  'ambassador.btn.Program': 'Program Guidelines',
  'ambassador.btn.Application': 'Application Form',
  'ambassador.introduce_1':
    'Biconomy ambassadors are our colleagues, friends, and business partners. They are passionate members of our community that support us in a variety of ways, including promoting the Biconomy web and mobile apps, providing feedback to improve our offerings and services, and helping new users with questions and concerns.',
  'ambassador.introduce_2':
    'As a Biconomy Ambassador, you can receive exclusive gifts, commission discounts, increased interest rates, early access to new features. You can also become our direct business partner and open a representative office of the exchange in your country.',
  'ambassador.help': 'How Ambassadors Help?',
  'ambassador.help.title_1': 'Inspire',
  'ambassador.help.text_1':
    'Inspire our communities with articles, conversations, events, etc. The organic community growth is our main goal.',
  'ambassador.help.title_2': 'Educate',
  'ambassador.help.text_2': 'Educate people using our vast resources and educational articles from Biconomy’s Learning Center. ',
  'ambassador.help.title_3': 'Protect',
  'ambassador.help.text_3':
    'Be an advocate by sharing knowledge about our services. Help prevent the “fake news” from competitors and scammers.',
  'ambassador.help.title_4': 'Localize',
  'ambassador.help.text_4':
    'Provide local insights in your native language. Share the news from our social media channels to help Biconomy become more locally relevant.',
  'ambassador.help.title_5': 'Guide',
  'ambassador.help.text_5':
    'Help drive brand awareness and inspire community engagement through media posts, press releases, YouTube videos and more.',
  'ambassador.help.title_6': 'Advertise',
  'ambassador.help.text_6':
    'If you’re a professional trader, blogger, YouTuber, or influencer, contact us and we’ll find a way to use your talent to expand our community.',
  'ambassador.faqs': 'FAQs',
  'ambassador.faqs.title_1': 'Who can become an ambassador?',
  'ambassador.faqs.text_1':
    'Anyone passionate about digital assets and various blockchain projects can become an ambassador. The most important is for you to have active cryptoenthusias networks, innovative mindset and be eager to learn about our business model. We will also be glad to see our potential business partners.',
  'ambassador.faqs.title_2': 'What will I get as an ambassador?',
  'ambassador.faqs.text_2':
    'You get the opportunity to directly participate in the life of the exchange, its development, and its business. You can also become a direct partner of the exchange with compatible commission!',
  'ambassador.faqs.title_3': 'How will I communicate with the team?',
  'ambassador.faqs.text_3':
    'A special Telegram chat is created for ambassadors, where you can communicate with colleagues from other regions and exchange experiences. Business partners communicate directly with the management of the exchange.',
  'ambassador.faqs.title_4': 'What is the commitment level expected from an ambassador?',
  'ambassador.faqs.text_4':
    'We consider any of your involvement - from a single post advertising of our exchange to full participation in the business and receiving a share of the company’s profits.',
};
